export const v1Pragma = '@kulav1proposal'

/** @param {Proposal} proposal*/
export function dateCreated(proposal) {
  return new Date(proposal.dateCreated)
}

/**
 * @param {Proposal} proposal
 * @param {DaoSettings} dao
 */
export function getProposalDaoDisplayTitle(proposal, dao) {
  const proposal_id_final_four = proposal.id.slice(-5)
  const dao_proposal_id = dao.daoTokenSymbol + '-' + proposal_id_final_four

  return proposal?.title
    ? `${proposal.title} (${dao_proposal_id})`
    : dao_proposal_id
}

export function createV1ProposalPayload({ title, description }) {
  const text = JSON.stringify({
    title,
    description,
    createdTs: Date.now(),
  })

  return v1Pragma + text
}

export function isV1ProposalPayload(payload) {
  return payload.startsWith(v1Pragma)
}

export function unpackV1ProposalPayload(payload) {
  if (payload.startsWith(v1Pragma)) {
    const data = JSON.parse(payload.replace(v1Pragma, ''))
    return {
      title: data.title,
      description: data.description,
      createdTs: data.createdTs,
    }
  }
  throw new Error('Invalid proposal payload')
}
